/**
 * @feature landing-page
 * @owner das-finsuite-application-dev
 * @description Fetches pre-computed AtoZ news feed from S3 for the landing page ticker.
 *
 * The Lambda (FinSuite-AtoZNewsFeedProcessor) runs hourly 7AM–7PM PST and writes
 * news-feed-current.json with merged items from all uploaded AtoZ topic feeds (60-day retention).
 */

import { GetObjectCommand } from '@aws-sdk/client-s3';
import { getS3Client } from 'src/services/aws/S3Service';
import { S3_ENV_CONSTANTS } from 'src/constants/EnvironmentConstants';

export interface NewsFeedItem {
  feedId: string;
  title: string;
  teaserContent: string;
  authorName: string;
  sourceType: string;
  category: string;
  priority: string;
  topic: string;
  publishTime: number;
  likedCount: number;
  commentsCount: number;
}

const S3_KEY = 'upstream/A_TOZ_NEWS_FEED/news-feed-current.json';

/**
 * Fetches news feed items from the pre-computed S3 file.
 * Returns empty array on error (ticker hides gracefully).
 */
export async function fetchNewsFeed(): Promise<NewsFeedItem[]> {
  try {
    const s3Client = getS3Client();
    if (!s3Client) return [];

    const bucket = S3_ENV_CONSTANTS.ENVIRONMENT_VARIABLES.Bucket;
    const resp = await s3Client.send(new GetObjectCommand({ Bucket: bucket, Key: S3_KEY }));
    const text = await resp.Body!.transformToString();
    const response = JSON.parse(text) as { items: NewsFeedItem[] };
    return response.items || [];
  } catch {
    return [];
  }
}
